import React from 'react';
import { Table, Tag } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { LegacyCoach } from '../../types';

interface CoachTableProps {
  coaches: LegacyCoach[];
  onEdit?: (id: string, coach: LegacyCoach) => void;
  onDelete?: (id: string) => void;
  onView?: (coach: LegacyCoach) => void;
  selectedRowKeys?: React.Key[];
  onSelectionChange?: (keys: React.Key[]) => void;
  loading?: boolean;
}

const CoachTable: React.FC<CoachTableProps> = ({
  coaches,
  onEdit,
  onDelete,
  onView,
  selectedRowKeys = [],
  onSelectionChange,
  loading = false
}) => {
  const columns: ColumnsType<LegacyCoach> = [
    {
      title: 'Name',
      dataIndex: 'firstName',
      key: 'name',
      render: (_, record) => `${record.firstName} ${record.lastName}`,
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status: string) => (
        <Tag color={status === 'Active' ? 'green' : status === 'Onboarding' ? 'blue' : 'red'}>
          {status}
        </Tag>
      ),
    },
    {
      title: 'Clients',
      dataIndex: 'assignedClients',
      key: 'clients',
    },
    {
      title: 'Rating',
      dataIndex: 'performanceRating',
      key: 'rating',
      render: (rating: number) => rating > 0 ? `${rating.toFixed(1)}/5` : 'N/A',
    },

  ];

  const rowSelection = onSelectionChange ? {
    selectedRowKeys,
    onChange: onSelectionChange,
  } : undefined;

  return (
    <Table
      dataSource={coaches}
      columns={columns}
      rowKey="id"
      rowSelection={rowSelection}
      loading={loading}
      onRow={(record) => ({
        onDoubleClick: () => onView?.(record),
        style: { cursor: 'pointer' }
      })}
      pagination={{
        pageSize: 25,
        showSizeChanger: true,
      }}
    />
  );
};

export default CoachTable; 